import { slicedToArray as _slicedToArray, typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useCallback, useEffect } from 'react';
import { useGetStickyHeight, useStickyHeight } from '@bucketplace/ui';
import '@emotion/react';
import { isInApp } from '../utils/dom.js';
import 'query-string';

function useScrollIntoAnchor(_ref) {
  var targetId = _ref.targetId,
    isLoading = _ref.isLoading,
    initialAnchor = _ref.initialAnchor;
  var containerRef = useRef(null);
  var getStickyHeight = useGetStickyHeight();
  var isRedirect = useRef(false);
  var _useState = useState(!initialAnchor),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEnd = _useState2[0],
    setAnchorEnd = _useState2[1];
  var outerStickyData = useStickyHeight(containerRef, anchorEnd ? 'bottom' : 'top');
  var current = outerStickyData.current,
    min = outerStickyData.min,
    max = outerStickyData.max;
  var showGNB = isInApp() ? true : max !== 0 && (current === min || current === max);
  var clickAnchor = function clickAnchor(targetId, smooth) {
    setAnchorEnd(false);
    scrollToTarget(targetId, smooth);
  };
  var scrollToTarget = useCallback(function (targetId, smooth) {
    var targetElements = document.querySelectorAll("#".concat(targetId));
    var targetElement = targetElements === null || targetElements === void 0 ? void 0 : targetElements[targetElements.length - 1];
    if (!targetElement) {
      return;
    }
    var bounds = targetElement.getBoundingClientRect();
    var top = Math.round(bounds.top);
    var min = outerStickyData.min,
      max = outerStickyData.max;
    var absoluteTop = Math.round(window.pageYOffset + top);
    var scrollY = window.scrollY || document.documentElement.scrollTop;
    var stickyOffset = getStickyHeight(absoluteTop - 1);
    if (stickyOffset === top) {
      setAnchorEnd(true);
      return;
    }
    var stickyHeight = stickyOffset - max;
    var direction = scrollY + max < absoluteTop ? 'up' : 'down';
    var diff;

    // 모바일 사이즈
    if (min === 0) {
      if (direction === 'up') {
        diff = -stickyHeight;
      } else {
        diff = -stickyOffset;
      }
      // 태블릿, 데스크탑 사이즈
    } else {
      if (direction === 'up') {
        diff = -max;
      } else {
        diff = -stickyOffset;
      }
    }
    window.scrollTo({
      top: absoluteTop + diff,
      behavior: smooth ? 'smooth' : undefined
    });
    setAnchorEnd(true);
  }, [getStickyHeight, outerStickyData]);
  useEffect(function () {
    var perfEntries = performance.getEntriesByType('navigation');
    var initialLoad = false;
    /**
     * safari 15 버전부터 지원
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type}
     */
    if (_typeof(perfEntries) === 'object') {
      var type = performance.navigation.type;
      initialLoad = type === PerformanceNavigation.TYPE_RELOAD || type === PerformanceNavigation.TYPE_NAVIGATE;
    } else {
      var _type = perfEntries[(perfEntries === null || perfEntries === void 0 ? void 0 : perfEntries.length) - 1].type;
      initialLoad = _type === 'reload' || _type === 'navigate';
    }
    if (initialLoad && initialAnchor && !isLoading && !isRedirect.current && showGNB) {
      window.history.scrollRestoration = 'manual';
      isRedirect.current = true;
      setTimeout(function () {
        scrollToTarget(targetId);
      }, 1000);
    }
  }, [initialAnchor, isLoading, showGNB, scrollToTarget, targetId]);
  useEffect(function () {
    window.history.scrollRestoration = 'auto';
    return function () {
      window.history.scrollRestoration = 'auto';
      isRedirect.current = false;
    };
  }, []);
  return {
    containerRef: containerRef,
    scrollToTarget: clickAnchor,
    anchorEnd: anchorEnd
  };
}

export { useScrollIntoAnchor };
//# sourceMappingURL=useScrollIntoAnchor.js.map
